"use client";

import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const [showBackToTop, setShowBackToTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const academicLinks = [{
    label: "High School Programs",
    href: "#"
  }, {
    label: "Undergraduate Degrees",
    href: "#"
  }, {
    label: "Faculty & Staff",
    href: "#"
  }, {
    label: "Academic Calendar",
    href: "#"
  }];
  const communityLinks = [{
    label: "Student Life",
    href: "#"
  }, {
    label: "Campus Events",
    href: "#"
  }, {
    label: "Alumni Network",
    href: "#"
  }, {
    label: "Parent Resources",
    href: "#"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Accessibility",
    href: "#"
  }, {
    label: "Non-Discrimination",
    href: "#"
  }];
  const socialLinks = [{
    label: "Facebook",
    href: "#"
  }, {
    label: "Twitter",
    href: "#"
  }, {
    label: "LinkedIn",
    href: "#"
  }, {
    label: "Instagram",
    href: "#"
  }];
  return <footer id="footer" className="dark bg-background text-foreground py-16 px-4 md:px-8" ref={ref}>
      <div className={`max-w-7xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545674/img/edusphere_logo_white.png" alt="EduSphere" className="h-7" />
            </Link>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-foreground">
              Academic
            </h3>
            <ul className="space-y-3">
              {academicLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-foreground transition-all duration-[var(--duration-fast)] hover:font-medium inline-block">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-foreground">
              Community
            </h3>
            <ul className="space-y-3">
              {communityLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-foreground transition-all duration-[var(--duration-fast)] hover:font-medium inline-block">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-foreground">
              Legal
            </h3>
            <ul className="space-y-3">
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-foreground transition-all duration-[var(--duration-fast)] hover:font-medium inline-block">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-display font-bold text-lg mb-4 text-foreground">
              Social
            </h3>
            <ul className="space-y-3">
              {socialLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-foreground/80 hover:text-foreground transition-all duration-[var(--duration-fast)] hover:font-medium inline-block">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="mb-8 bg-foreground/20" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground/70">© 2026 SSC Madurai. All rights reserved.</p>

          {showBackToTop && <Button onClick={scrollToTop} variant="ghost" size="sm" className="text-foreground/80 hover:text-foreground gap-2 transition-all duration-[var(--duration-fast)]" aria-label="Back to top">
              <span>Back to Top</span>
              <ArrowUp className="size-4" />
            </Button>}
        </div>
      </div>
    </footer>;
}